import { observer } from 'mobx-react';
import * as React from 'react';
import { T, TPlainTextKey } from '../../../Translations';
import { fromNullable } from 'maybeasy';
import { fromBool } from '@execonline-inc/maybe-adapter';

interface Props {
  htmlFor?: string;
  className?: string;
  labelText: TPlainTextKey;
  required?: boolean;
}

const Label: React.FC<Props> = (props) => {
  return (
    <label
      className={fromNullable(props.className).getOrElse(
        () => 'my-0 ml-0 mr-[5px] block pb-1 text-left text-base tracking-wide opacity-80',
      )}
      htmlFor={props.htmlFor}
      data-test-label={props.labelText}
    >
      <T kind={props.labelText} />
      {fromNullable(props.required)
        .andThen((v) => fromBool(v, v))
        .map(() => (
          <span className="[&:not(focus)]:[&:not(active)]:sr-only">
            <T kind={'Required'} />
          </span>
        ))
        .getOrElse(() => (
          <></>
        ))}
    </label>
  );
};

export default observer(Label);
